import React, {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import Avatar from '../../components/Avatar';
import Phone from '../../components/Phone';
import {MUTATION_CLIENT_UPDATE, QUERY_USER} from '../Client/graphql';
import FileSave from '../File/Save';
import {MUTATION_USER_SETTINGS} from './graphql';
import Select from 'react-select';
import {QUERY_CITY_LIST} from '../City/graphql';
import {MODES} from '../Client/constants';

const UserDetail = () => {
  const {user} = useQuery(QUERY_USER).data;

  const {cityList} = useQuery(QUERY_CITY_LIST).data || {cityList: []};

  const [settings, settingsResp] = useMutation(MUTATION_USER_SETTINGS);
  const [clientUpdate, clientUpdateResp] = useMutation(MUTATION_CLIENT_UPDATE);

  const input = {
    id: user.id,
    fullname: user.fullname,
    phone: user.phone,
    avatar: user.avatar ? user.avatar.id : null,
  };

  const clientInput = {
    city: user.client.city.id,
    mode: user.client.mode,
  };

  return (
    <div className="py-4">
      <div className="row justify-content-between">
        <div className="col-auto font-5 fw-bold">Настройки</div>
        {(settingsResp.loading || clientUpdateResp.loading) && (
          <div className="col-auto text-danger">сохранение ...</div>
        )}
      </div>
      <div className="row gx-lg-5 gy-4 mt-4">
        <div className="col-lg-6">
          <div className="row gx-lg-3 align-items-center">
            <div className="col-auto">
              <Avatar user={user} size={100} />
            </div>
            <div className="col-auto">
              <div className="mb-2">Лого</div>
              <FileSave
                onFileSave={file => settings({variables: {input: {...input, avatar: file.id}}})}
                component={(loading, error) => (
                  <div className="btn btn-secondary">Загрузить файл (jpg, png){loading ? '...' : ''}</div>
                )}
              />
            </div>
          </div>
          <div className="mt-3">
            <div className="mb-2">Полное имя</div>
            <input
              onBlur={e => settings({variables: {input: {...input, fullname: e.target.value}}})}
              defaultValue={user.fullname}
              type="text"
              className="form-control"
            />
          </div>
          <div className="mt-3">
            <div className="mb-2">Телефон</div>
            <Phone
              onBlur={value => settings({variables: {input: {...input, phone: value}}})}
              defaultValue={user.phone}
              type="text"
              className="form-control"
            />
          </div>
          <div className="mt-3">
            <div className="mb-2">Город</div>
            <Select
              options={cityList}
              defaultValue={user.client.city}
              onChange={op => clientUpdate({variables: {input: {...clientInput, city: op.id}}})}
              getOptionValue={op => op.id}
              getOptionLabel={op => op.name}
            />
          </div>
          <div className="mt-3">
            <div className="mb-2">Скорость обучения</div>
            <Select
              options={Object.keys(MODES).map(x => MODES[x])}
              defaultValue={MODES[user.client.mode]}
              onChange={op => clientUpdate({variables: {input: {...clientInput, mode: op.value}}})}
            />
          </div>
        </div>
        <div className="col-lg-6">
          {/*<ContactList />*/}
          <div className="font-4 fw-bold">Контакты для беседы</div>
          <div className="mt-3">
            <div className="mb-2">Skype ID</div>
            <input
              onBlur={e => clientUpdate({variables: {input: {...clientInput, skype: e.target.value}}})}
              defaultValue={user.client.skype}
              type="text"
              className="form-control"
            />
          </div>
          <div className="mt-3">
            <div className="mb-2">Zoom ID</div>
            <input
              onBlur={e => clientUpdate({variables: {input: {...clientInput, zoom: e.target.value}}})}
              defaultValue={user.client.zoom}
              type="text"
              className="form-control"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
